import { useQuery } from '@tanstack/react-query';
import { Link } from 'wouter';
import { FileText, AlertCircle } from 'lucide-react';
import { Layout } from '../components/Layout';
import { api } from '../lib/api';

export function MyCharts() {
  const { data: variants = [], isLoading } = useQuery({
    queryKey: ['myCharts'],
    queryFn: () => api.charts.getPersonalForUser(),
  });

  return (
    <Layout title="My Charts">
      <div className="p-4 md:p-6 max-w-3xl mx-auto">
        <h2 className="text-xl font-bold mb-4">My Chart Versions</h2>
        {isLoading ? (
          <div className="text-center py-12 text-gray-400">Loading...</div>
        ) : variants.length === 0 ? (
          <div className="text-center py-16">
            <FileText className="w-12 h-12 text-gray-600 mx-auto mb-3" />
            <p className="text-gray-400">No personal chart versions yet.</p>
            <p className="text-sm text-gray-500 mt-1">Open a song and create "My Version" from the base chart.</p>
          </div>
        ) : (
          <div className="space-y-2">
            {variants.map((v: any) => (
              <Link key={v.id} href={`/editor/personal/${v.id}`}>
                <div className="flex items-center gap-3 p-3 bg-surface-900 border border-surface-700 rounded-lg hover:border-accent-500/30 transition-colors cursor-pointer group">
                  <FileText className="w-4 h-4 text-accent-400 shrink-0" />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium truncate group-hover:text-accent-300 transition-colors">{v.songTitle}</p>
                    <div className="flex items-center gap-2 text-xs text-gray-500">
                      {v.songArtist && <span>{v.songArtist}</span>}
                      <span>{v.bandName}</span>
                      <span>v{v.versionNumber}</span>
                    </div>
                  </div>
                  {v.lastSeenBaseVersion < (v.baseVersionNumber || Infinity) && (
                    <span className="flex items-center gap-1 text-xs bg-amber-500/20 text-amber-400 px-2 py-0.5 rounded-full shrink-0">
                      <AlertCircle className="w-3 h-3" />
                      Updated
                    </span>
                  )}
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
